import { ProductTypeEnum } from '@systemeio/digital-store-shared'
import ItemContent from 'modules/stores/store/components/item-content'
import ItemWrapper from 'modules/stores/store/components/item-wrapper'
import {
  PhysicalProductItemEditType,
  PhysicalProductItemViewType,
  ProductDownloadItemEditType,
  ProductDownloadItemViewType,
  ProductECourseItemEditType,
  ProductECourseItemViewType,
} from 'modules/stores/store/content/product/types/product-interface'
import { getItemUpdateData } from 'modules/stores/store/content/product/utils/get-item-update-data'
import { useChangeItemDraft } from 'modules/stores/store/hooks/use-change-item-draft'
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item'
import { useItemProductActions } from './hooks/use-item-product-actions'

const Content = (
  item: ProductDownloadItemViewType | ProductECourseItemViewType | PhysicalProductItemViewType,
) => {
  const {
    deleteProductItem,
    deleteECourseItem,
    deletePhysicalProductItem,
    updateProduct,
    updateECourse,
    updatePhysicalProduct,
  } = useItemProductActions()

  const { onDelete } = useDeleteItem()

  const onDeleteHandler = () =>
    onDelete({
      deleteCallback: () => {
        switch (item.productType) {
          case ProductTypeEnum.eCourse:
            return deleteECourseItem(item.id)
          case ProductTypeEnum.download:
            return deleteProductItem(item.id)
          case ProductTypeEnum.physicalProduct:
            return deletePhysicalProductItem(item.id)
        }
      },
      itemId: item.itemId,
    })

  const { onChangeItemDraft } = useChangeItemDraft()

  const updateData = async (
    item: ProductDownloadItemViewType | ProductECourseItemViewType | PhysicalProductItemViewType,
    draft: boolean,
  ) => {
    switch (item.productType) {
      case ProductTypeEnum.download:
        await updateProduct(
          item.id,
          getItemUpdateData({
            item: {
              ...(item as ProductDownloadItemEditType),
              draft,
            },
          }),
        )
        break
      case ProductTypeEnum.eCourse:
        await updateECourse(
          item.id,
          getItemUpdateData({
            item: {
              ...(item as ProductECourseItemEditType),
              draft,
            },
          }),
        )
        break
      case ProductTypeEnum.physicalProduct:
        await updatePhysicalProduct(
          item.id,
          getItemUpdateData({
            item: {
              ...(item as PhysicalProductItemEditType),
              draft,
            },
          }),
        )
        break
    }
  }

  const onSaveDraft = () => {
    return onChangeItemDraft({
      callback: async () => await updateData(item, true),
      itemId: item.itemId,
      draft: true,
    })
  }

  const onPublish = () => {
    return onChangeItemDraft({
      callback: async () => await updateData(item, false),
      itemId: item.itemId,
      draft: false,
    })
  }

  return (
    <ItemWrapper id={item.itemId}>
      <ItemContent
        draft={item.draft}
        onDelete={onDeleteHandler}
        onSaveDraft={onSaveDraft}
        onPublish={onPublish}
        itemId={item.itemId}
        title={item.title}
        itemType={item.type}
        productType={item.productType}
        thumbnail={item.thumbnail}
      />
    </ItemWrapper>
  )
}

export default Content
